module.exports = __webpack_public_path__ + "static/media/garlic.5e1a31e3.png";